<template>
  <!-- Lista de valores: parametro -->
  <div class="modal fade" id="ModalParametroLOV" tabindex="-1" aria-labelledby="ModalLabelLOV" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title" id="ModalLabelLOV">
            <i class="fa fa-user-plus"></i> {{ tituloLOV }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <div class="mb-3">
          <table class="tablaBusqueda">
            <tr>
              <td><label for="nombre" class="form-label">Nombre</label></td>
              <td><input type="text" class="form-control" id="nombreBusquedaLOV" name="nombreBusquedaLOV"
                  v-model="nombreBusquedaLOV" style="width: 500px; text-transform:uppercase;" required></td>
              <td>
                <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaLOV(1)"
                  title="Buscar registros">
                  Buscar
                </button>
              </td>
            </tr>
          </table>
        </div>
        <table class="table table-striped" id="sampleTableLOV">
          <thead>
            <tr>
              <th scope="col">nombre</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="parametro in datosPaginadosLOV" :key="parametro.idparametro">
                  <td><a href="#" v-on:click="seleccionarRegistro(parametro.idParametro, parametro.nombre)"
                      data-bs-target="#ventanaModal" data-bs-toggle="modal">{{ parametro.nombre }}</a></td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="Page navigation example">
          <div class="row" style="text-align: center;">
            <div class="col"></div>
            <div class="col">
              <ul class="pagination">
                <li class="page-item" v-on:click="getPreviousPageLOV()"><a class="page-link" href="#">Anterior</a></li>
                <li class="page-item"><a class="page-link" href="#">{{ paginaActualLOV }}</a></li>
                <li class="page-item" v-on:click="getNextPageLOV()"><a class="page-link" href="#">Siguiente</a></li>
              </ul>
            </div>
            <div class="col"></div>
          </div>
        </nav>
      </div>
    </div>
  </div>
<!-- Lista de valores: Parametro -->
</template>
<script>
import api from "@/services/api";
export default {
  data() {
    return {
      // Lista de valores: Parametro
      nombreBusquedaLOV: '',
      tituloLOV: 'Lista de Parametro',
      ParametroLOV: [],
      elementosPorPaginaLOV: 10,
      datosPaginadosLOV: [],
      paginaActualLOV: 1
      // Lista de valores: Parametro
    }
  },
  methods: {
    // Lista de valores: Parametro
    totalPaginasLOV() {
      return Math.ceil(this.ParametroLOV.length / this.elementosPorPaginaLOV)
    },
    getDataPaginaLOV(noPagina) {
      if (this.nombreBusquedaLOV != null && this.nombreBusquedaLOV !== ""){
        api.get('/vwparametros/nombre/'+this.nombreBusquedaLOV).then(response=>{
          this.ParametroLOV = response.data.reverse();
          this.paginaActualLOV = noPagina;
          this.datosPaginadosLOV = [];
          let ini = (noPagina * this.elementosPorPaginaLOV) - this.elementosPorPaginaLOV;
          let fin = (noPagina * this.elementosPorPaginaLOV);
          this.datosPaginadosLOV = this.ParametroLOV.slice(ini, fin);
          this.datosPaginadosLOV = this.ParametroLOV.slice(ini, fin);
        });
      }
      else{
        alert("ERROR: Ingrese un valor de consulta Parametro");
      }
    },
    getPreviousPageLOV() {
      if (this.paginaActualLOV > 1) {
        this.paginaActualLOV--;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    getNextPageLOV() {
      if (this.paginaActualLOV < this.totalPaginasLOV()) {
        this.paginaActualLOV++;
      }
      this.getDataPaginaLOV(this.paginaActualLOV);
    },
    seleccionarRegistro(p_idParametro, p_nombre) {
      this.$emit("DatosParametro", { idParametro: p_idParametro, nombre: p_nombre });
    }
  }
}
</script>
